export const CART_PRODUCTS_LIST_TEST_ID = {
  cartLink: 'cart-link',
  cartHeading: 'cart-heading',
  emptyCart: 'empty-cart-button',
  planName: 'plan-name',
  pricings: 'pricings',
  inPersonRate: 'in-person-rate',
  keyedInRate: 'keyed-in-rate',
};
